import { createFileRoute, redirect } from '@tanstack/react-router';

import { resolveDefaultAppPath } from '@auth/data-access';

export const Route = createFileRoute('/')({
  beforeLoad: ({ context }) => {
    throw redirect({
      to: resolveDefaultAppPath(context.auth.user),
    });
  },
});
